// extracted by mini-css-extract-plugin
export default {"container":"companysettings_container__oAT2t","TabsContent":"companysettings_TabsContent__POGf7","RowTabs":"companysettings_RowTabs__FbLeK"};